<template>
    <div class="animated fadeIn">        
        <b-card>
            <div slot="header">
                Approval/Task Form
                <div class="card-header-actions">
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
            <b-row>
                <b-col md="5">
                    <b-input-group >
                        <b-input-group-prepend><label>Doc./Task Name</label></b-input-group-prepend>
                        <b-form-input v-model="model.wftypekey" readonly></b-form-input>
                    </b-input-group>
                    <b-input-group >
                        <b-input-group-prepend><label>Doc./Task Detail</label></b-input-group-prepend>
                        <b-form-textarea :rows="3" :max-rows="10" v-model="model.taskdetail" readonly></b-form-textarea>
                    </b-input-group>

                    <b-input-group >
                        <b-input-group-prepend><label>Requested By</label></b-input-group-prepend>
                        <b-form-input v-model="model.createdby" readonly></b-form-input>                                        
                        <b-form-input v-model="model.createdon" readonly class="ml-1"></b-form-input>
                    </b-input-group>
                    <b-input-group>
                        <b-input-group-prepend><label>Requestor Position</label></b-input-group-prepend>
                        <b-form-input v-model="model.jabatan" readonly></b-form-input>                                        
                    </b-input-group>
                    <b-input-group>
                        <b-input-group-prepend><label>Department</label></b-input-group-prepend>
                        <b-form-input v-model="model.departemen" readonly></b-form-input>
                        <!-- <b-input-group-append><b-button variant="secondary" class="ml-1" @click="viewBudgetDept">View Budget</b-button></b-input-group-append> -->
                    </b-input-group>
                    <!-- <b-row no-gutters>
                        <b-col cols="6">
                            <label>Attachments</label>
                            <b-link @click="showAddAttachment=true" class="ml-2"><i class="fa fa-paperclip"></i> Add</b-link>

                        </b-col>
                        <b-col cols="6">
                            <div class="text-right">
                                <b-button variant="secondary" class="ml-1" size="sm" @click="viewBudgetProd">View Project/Production Budget</b-button>       
                            </div>                    
                        </b-col>
                    </b-row>
                    <div class="ml-4 mb-2">
                        <ol style="margin:0" v-if="(attachments.length>0)">
                            <li v-for="fl in attachments" :key="fl.attachmentKey">
                                <b-link @click="attachmentDownload(fl)">{{fl.attchFileNm}}</b-link>
                            </li>
                        </ol>
                        <ul style="margin:0" v-else>
                            <li>no attachment</li>
                        </ul>
                    </div> -->
                    <div v-show="((showForm==false) && (showQueue==false))">
                        <p>Your Comment</p>
                            <div class="ml-5 mb-2">
                            <b-form-textarea :rows="3" :max-rows="10" v-model="model.message" :state="!$v.model.message.$error" ></b-form-textarea>
                            </div>
                            <b-row class="justify-content-center mt-2 mb-2" v-if="(model.isTask==0)">
                                <b-button variant="success" @click="doAction('APPROVED')">Approve</b-button>
                                <!-- <b-button variant="warning" class="ml-1" @click="doAction('REVIEWED')">Review</b-button>
                                <b-button variant="info" class="ml-1" @click="showRouting">Routing</b-button> -->
                                <b-button variant="danger" class="ml-1" @click="doAction('REJECTED')">Reject</b-button>
                            </b-row>
                            <b-row class="justify-content-center mt-2 mb-2" v-if="(model.isTask==1)">
                                <b-button variant="success" class="ml-1" @click="doAction('COMPLETED')">Complete</b-button>
                                <!-- <b-button variant="warning" class="ml-1" @click="doAction('REVIEWED')">Review</b-button>
                                <b-button variant="info" class="ml-1" @click="showRouting">Routing</b-button>
                                <b-button variant="dark" class="ml-1" @click="showQueuing">Queued</b-button>
                                <b-button variant="primary" class="ml-1" @click="doAction('PROCESSED')">Started</b-button> -->
                                <b-button variant="danger" class="ml-1" @click="doAction('REJECTED')">Reject</b-button>
                            </b-row>
                    </div>
                    <div v-show="(showForm==true)">
                        <b-card >
                            <div slot="header">Routing Approval/Task 
                            </div>
                            <b-input-group >
                                <b-input-group-prepend><label>Route to</label></b-input-group-prepend>
                                <b-form-input readonly v-model="model.crewinfo" :state="!$v.model.routeToNik.$error"></b-form-input>
                                <b-input-group-append>
                                <b-btn text="Button" @click="lkuUserShow=true" >
                                    <i class="fa fa-search"></i>
                                </b-btn>
                                </b-input-group-append>
                            </b-input-group>
                            <b-input-group>
                                <b-input-group-prepend><label>Your Comment</label></b-input-group-prepend>
                                <b-form-textarea :rows="3" :max-rows="3" v-model="model.message" :state="!$v.model.message.$error" maxlength="900" ></b-form-textarea>
                            </b-input-group>
                            <b-row class="justify-content-center mt-1" >
                                <b-button variant="primary" @click="doRouting"><i class="fa fa-check"></i> Proceed Routing</b-button>
                                <b-button variant="secondary" class="ml-1" @click="closeRouting()" > <i class="fa fa-close"></i> Cancel Routing</b-button>
                            </b-row>
                        </b-card>
                    </div>
                    <div v-show="(showQueue==true)">
                        <b-card >
                            <div slot="header">Queuing Approval/Task 
                            </div>
                            <b-input-group >
                                <b-input-group-prepend><label>Est. Start Date</label></b-input-group-prepend>
                                <b-form-input type="date" v-model="model.postuntil" :state="!$v.model.postuntil.$error"></b-form-input>
                                <b-input-group-append><span class="input-group-text" > wait in Queue til the date</span></b-input-group-append>
                            </b-input-group>
                            <b-input-group>
                                <b-input-group-prepend><label>Your Comment</label></b-input-group-prepend>
                                <b-form-textarea :rows="3" :max-rows="3" v-model="model.message" :state="!$v.model.message.$error" ></b-form-textarea>
                            </b-input-group>
                            <b-row class="justify-content-center mt-1" >
                                <b-button variant="primary" @click="doQueuing"><i class="fa fa-check"></i> Proceed Queuing</b-button>
                                <b-button variant="secondary" class="ml-1" @click="closeQueuing()" > <i class="fa fa-close"></i> Cancel Queuing</b-button>
                            </b-row>
                        </b-card>
                    </div>
                    <label>Workflow process history</label>
                    <div class="report-wraper">
                        <table width="100%">
                        <thead>
                        <tr>
                        <th width="120px">Assign Date</th>
                        <th style="max-width:220px;" >Assign To</th>
                        <th style="max-width:80px;" >Action Take</th>
                        <th >Comment</th>
                        <th width="120px">Complete Date</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="row in history" :key="row.taskassignkey">
                        <td> {{row.assignstr | moment("dddd , DD-MMM-YYYY hh:mm:ss")}} </td>
                        <td :class="{expired: (row.actiontake=='EXPIRED')}" style="max-width:220px;">{{row.crewname}}</td>
                        <td :class="{expired: (row.actiontake=='EXPIRED')}" style="max-width:80px;" >{{row.actiontake}} 
                            <p v-if="(row.crewname !== row.actionBy)">{{row.actionBy}}</p></td>
                        <td :class="{expired: (row.actiontake=='EXPIRED')}">{{row.message}}</td>
                        <td><span v-if="(row.completeddate)">{{row.completeddate | moment("ddd DD-MMM-YYYY hh:mm:ss")}}</span></td>
                        </tr>
                        </tbody>
                        </table>
                    </div>
                </b-col>
                <b-col md="7">
                    <b-card no-body >
                        <iframe :src="reportUrl" frameborder="0"></iframe>
                    </b-card>
                </b-col>
            </b-row>
        </b-card>

        <b-modal v-model="lkuUserShow" size="lg" :hide-footer="true" title="List of User/Employee" :centered="true">
            <lku-user @click="onSelectLkuUser"></lku-user>
        </b-modal>        
    <b-modal v-model="budgetShow" size="lg" :title="budgetTitle" ok-only>
        <iframe :src="budgetUrl" frameborder="0"></iframe>
    </b-modal>
      <b-modal v-model="showAddAttachment" header-bg-variant="primary"  title="Add Attachment Form" size="lg" :centered="true" @ok="attachmentSave" ok-title="Save">
        <b-form @submit.stop.prevent="attachmentSave">
            <b-form-file
            v-model="file"
            :state="Boolean(file)"
            placeholder="Choose a file or drop it here..."
            drop-placeholder="Drop file here..."
            ></b-form-file>
            <div class="mt-3">Selected file: {{ file ? file.name : '' }}</div>        </b-form>
      </b-modal>
        <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    </div>    
</template>
<style lang="scss">
    .report-wraper {
         width:100%;
         overflow-x: auto;
         overflow-y: auto;
        min-height: 100px;
        border: 1px solid silver;
        table {
            font-size: smaller;
            th {
                border: 1px solid silver;
                padding: 0 15px;
                height: 30px;
                background: #e8e8e8;
            }              
            td {
                border: 1px solid silver;
                padding: 0 10px;
                height: 25px;
            }
            td.expired {
                background: red;
            }
            
            td.tebal {
                font-weight: bold;
            }
            
            td.subtotal {
                border-top: 2px solid #000 !important;
            }
        }
    }
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 130px;
            }
        }
    }

</style>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import moment from 'moment';
import lkuUser from "./lookup/lkuUser";
import task from "../apis/task";
import { validationMixin } from "vuelidate";
import { required, requiredIf, numeric } from "vuelidate/lib/validators";
toastr.init();

export default {   
  components: { Loading, lkuUser},
  mixins: [validationMixin],
  validations: {
        model: {
            taskassignkey: { required },
            message: { required },
            routeToNik: {required : (function() {
                if (this.model.isrouting == 0) {
                    return true;
                } else if (!(this.model.routeToNik)){
                    return false;
                } else return true;
            })},
            postuntil: {required : (function() {
                if (this.model.postponed == 0) {
                    return true;
                } else if (!(this.model.postuntil)){
                    return false;
                } else return true;
            })},
        },
        file: { required },
  }, 
  data() {
    return {
       isLoading:false,
        lkuUserShow:false,
        showQueue:false,
        showForm:false,
        reportUrl: `${location.origin}/#load`,
        budgetShow:false,
        budgetUrl: `${location.origin}/#load`,
        budgetTitle: `Preview Annual Budget`,
        showAddAttachment:false,
        model:{message:'', isrouting:0, routeToNik:'', postponed:0, postuntil:''},
        file:null,
        attachments:[], history:[]
    };
},
  computed: {
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    invalidFile() {
      this.$v.file.$touch();
      return this.$v.file.$invalid;
    },
  },
  created: async function(){
    toastr.info('Loading Appoval/Task Detail, please wait')
    if (this.$route.params.key)  {
          try {
              console.log("#this.$route.params: ", this.$route.params);
            this.reportUrl = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${this.$route.params.taskkey}`;
            console.log("#this.reportUrl: ", this.reportUrl);
            if (this.$route.params.key == '92b0564a-86f0-11e8-bc6e-1c394733789f')
                this.reportUrl = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/818087A0-9AF5-11E9-B25B-D1EDAAB41F0B`;
            
            const resp = await task.detail(this.$route.params);  
            toastr.clear;
            if (resp.success){
                // this.reportUrl = resp.reportUrl;
                const row = resp.data[0][0];
                row.tahun = moment(row.createdon).format('YYYY');
                row.createdon = moment(row.createdon).format('dddd,  DD-MMM-YYYY hh:mm:ss');
                for (var key in row) {
                    this.model[key] = row[key];
                }
                // console.log('this.model : ',this.model);
                this.history = resp.data[1];
                this.attachments = resp.data[2];
            } else {
                console.log('error msg: ', resp.message);
                console.log('error Sql: ', resp.sql);
                toastr.error(JSON.stringify(resp), "ERROR MESSAGE");                              
            }
          } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
          }
    } else {
          try {
            this.reportUrl = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/818087A0-9AF5-11E9-B25B-D1EDAAB41F0B`;
            const resp = await task.detail({key:'92b0564a-86f0-11e8-bc6e-1c394733789f'});  
            toastr.clear;
            if (resp.success){
                const row = resp.data[0][0];
                row.createdon = row.createdon ? moment(row.createdon).format('dddd , DD-MMM-YYYY hh:mm:ss') : '';
                for (var key in row) {
                    this.model[key] = row[key];
                }
                this.history = resp.data[1];
                this.attachments = resp.data[2];
            } else {
                console.log('error msg: ', resp.message);
                console.log('error Sql: ', resp.sql);
                toastr.error(JSON.stringify(resp), "ERROR MESSAGE");                              
            }
          } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
          }

    }
  },
  methods: {
    attachmentSave : async function(evt) {
          evt.preventDefault()
          if (this.invalidFile) {
              console.log('validation : ', this.$v.file);
              console.log('model : ',this.file);
            //   this.showAddAttachment=true;
              toastr.error('Please choose a file');
        } else {
            toastr.info(`Attachment Save`);
            this.isLoading=true;
            try {
                const formData = new FormData();
                formData.append('file', this.file);
                formData.append('filename', this.file.name);
                formData.append('tablekey', this.model.taskkey);
                const response = await task.attachmentSave(formData);
                console.log('response : ',response);
                this.attachments = response;

                this.showAddAttachment=false;
                this.isLoading=false;    
            } catch (error) {
                this.isLoading=false;
                console.log(error);
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }
            }
        }
    },   
    attachmentDownload : async function(fl) {
        this.isLoading=true;
        try {
            const response = await task.attachmentDownload(fl);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
    },   
    viewBudgetProd : async function() {
        if (this.model.pjxhdrkey) {
            //   router.push({name :'budget.mstrbudgetprogress', params: { pjxhdrkey: this.model.pjxhdrkey}});
              let routeData = router.resolve({path: `/budget/progress-budget-production/${this.model.pjxhdrkey}`});
              window.open(routeData.href, '_blank');
        } else {
            toastr.warn(`it is not related to Budget Production/Project`);
        }
    },   
    viewBudgetDept2 : async function() {
        let routeData = router.resolve({path: `/budget/annual-budget-progress/${this.model.layout}/${this.model.departkd}/${this.model.departemen}/${moment(this.model.assignstr).format("YYYY-01-01")}/${moment(this.model.assignstr).endOf("month").format("YYYY-MM-DD")}`});
        window.open(routeData.href, '_blank');
    },   
    viewBudgetDept : async function() {
        this.isLoading=true;
        this.budgetUrl= await task.viewBudgetDept(this.model);
        this.isLoading=false;
        this.budgetTitle='Preview Budget Department';  
        this.budgetShow=true;
    },   
    showRouting: function(data) {
      this.model.isrouting=1;  
      this.showForm=true;
    },
    closeRouting(){
      this.model.isrouting=0;  
      this.model.routeToNik = '';
      this.showForm=false;
    },    
    async doRouting(){
          if (this.invalidModel) {
              console.log('validation : ', this.$v.model);
              console.log('model : ',this.model);
              toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
            try {
                this.isLoading=true;
                var param = {
                    taskassignkey: this.model.taskassignkey,
                    actionTake: 'ROUTING',
                    comment: this.model.message || (`Route to ${this.model.crewinfo}`),
                    isrouting: 1,
                    routeToNik: this.model.routeToNik,
                    routeToUser: this.model.routeToUser || '',
                    postponed: 0,
                    postuntil: ''
                }
                // console.log('doRouting action param:',param);
                const res= await task.doaction(param);
                this.isLoading=false;
                if (res.success == true) {
                    this.close();
                } else toastr.error(res.message);
                this.showForm=false;
            } catch (error) {
                this.isLoading=false;
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }              
            }
        }
    },    
    showQueuing: function(data) {
      this.model.isrouting=1;  
      this.showQueue=true;
    },
    closeQueuing(){
      this.model.isrouting=0;  
      this.model.routeToNik = '';
      this.showQueue=false;
    },    
    async doQueuing(){
          if (this.invalidModel) {
              console.log('validation : ', this.$v.model);
              console.log('model : ',this.model);
              toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
            try {
                this.isLoading=true;
                var param = {
                    taskassignkey: this.model.taskassignkey,
                    actionTake: 'PENDING',
                    comment: this.model.message || ('Queued, est. starting @' + moment(this.model.postuntil, 'YYYY-MM-DD').format('DD MMM YYYY')),
                    isrouting: 0,
                    routeToNik: '',
                    postponed: 1,
                    postuntil: this.model.postuntil
                }
                const res= await task.doaction(param);
                this.isLoading=false;
                if (res.success == true) {
                    this.close();
                } else toastr.error(res.message);
                this.showForm=false;
            } catch (error) {
                this.isLoading=false;
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }              
            }
        }
    },    
    async doAction (actionname) {
        if (this.invalidModel) {
              console.log('validation : ', this.$v.model);
              console.log('model : ',this.model);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
            try {
                this.isLoading=true;
                var param = {
                    taskassignkey: this.model.taskassignkey,
                    actionTake: actionname,
                    comment: this.model.message,
                    routeToNik: this.model.routeToNik || '',
                    routeToUser: this.model.routeToUser || '',
                    postponed: 0,
                    postuntil: ''
                }
                // console.log('action param:',param);
                const res= await task.doaction(param);
                this.isLoading=false;
                if (res.success == true) {
                    this.close();
                } else toastr.error(res.message);
            } catch (error) {
                this.isLoading=false;
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }              
            }
        }

    },   
    onSelectLkuUser: async function (_selected) {
        this.model.crewinfo = _selected.crewnik.trim() + ' | ' + _selected.full_name.trim();
        this.model.crewkey = _selected.crewkey;
        this.model.routeToNik = _selected.crewnik.trim();
        this.model.routeToUser = _selected.username.trim();
        // console.log('model:',this.model);

        this.lkuUserShow=false;
    },
    close(){
        router.push({name:'app.home'});
        //   router.push("home");
    }
  }
};
</script>
